import { initReactI18next } from "react-i18next";
import i18next from "i18next";

import local_storage from "../utils/local_storage";
import storageMap from "../_constants/storageMap";
import en from "./en";
import es from "./es";
import fr from "./fr";
import de from "./de";
import nl from "./nl";

const currentLanguage = local_storage.get(storageMap.common.LANGUAGE) || "en";
local_storage.set(storageMap.common.LANGUAGE, currentLanguage);

i18next.use(initReactI18next).init({
  debug: false,
  lng: currentLanguage,
  fallbackLng: "en",
  resources: {
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    de: { translation: de },
    nl: { translation: nl },
  },
  interpolation: {
    escapeValue: false,
  },
  parseMissingKeyHandler: () => "MISSING_TRANSLATION_KEY",
});
